/**
 * Generates a map from an array of objects with numeric ids. Useful for creating 'reorder maps'.
 * Ex: [{id: 20}, {id: 50}, {id: 2}] => { '20': 1, '50': 2, '2': 3 }
 */
export const idArrayToIndexMap = (arr: Array<{ id: number }>) =>
  arr.reduce(
    (map, { id }, index) => ({ ...map, [id.toString()]: index + 1 }),
    {} as Record<string, number>,
  )
